import React from "react";
import "./DashboardHero.scss";
import { useSelector } from "react-redux";

function DashboardHero() {
  const { filters } = useSelector((state) => state.filters);
  const { categories } = useSelector((state) => state.category);
  const { subcategories } = useSelector((state) => state.subcategories);
  const { subsubcategories } = useSelector((state) => state.subsubcategories);
  const { products } = useSelector((state) => state.products);

  const stats = [
    {
      label: 'Products',
      value: products?.length || 0,
    },
    {
      label: 'Categories',
      value: categories?.length || 0,
    },
    {
      label: 'Subcategories',
      value: subcategories?.length || 0,
    },
    {
      label: 'Sub-Subcategories',
      value: subsubcategories?.length || 0,
    },
    {
      label: 'Filters',
      value: filters?.length || 0,
    },
  ];

  return (
    <div className="dashboard-hero">
      <h1>Загальна статистика</h1>

      <div className="card-grid">
       {stats.map((item) => (
          <div className="card" key={item.label}>
            <p className="card-title">{item.label}</p>
            <p className="card-value">{item.value}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

export default DashboardHero;
